<template>
  <Filtros :filtros="filtros" />
</template>

<script>
import Filtros from './Index.vue';
export default {
  name: 'FiltrosDefault',
  components: {
    Filtros
  },
  props: {
    filtros: {
      type: Array,
      required: true
    }
  }
}
</script>
